import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_12 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_15 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = {
  key: 3,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_18 = { class: "control-label col-sm-6" }
const _hoisted_19 = { class: "col-sm" }
const _hoisted_20 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_21 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_22 = { class: "col-sm" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_25 = { class: "control-label col-sm-6" }
const _hoisted_26 = { class: "col-sm" }
const _hoisted_27 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_28 = { class: "control-label col-sm-6" }
const _hoisted_29 = { class: "col-sm" }
const _hoisted_30 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_31 = { class: "control-label col-sm-6" }
const _hoisted_32 = { class: "col-sm" }
const _hoisted_33 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_34 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_35 = { class: "col-sm" }
const _hoisted_36 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_37 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_38 = { class: "col-sm" }
const _hoisted_39 = {
  key: 3,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_40 = { class: "control-label col-sm-6" }
const _hoisted_41 = { class: "col-sm" }
const _hoisted_42 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_43 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_44 = { class: "col-sm" }

import { watch , ref, inject} from 'vue'
import { usePreventivo } from '../../composable/usePreventivo'
import FormAltroHelper from "../../pages/preventivi/json/altro/helper.json";
import DettaglioPreventivoHelper from "../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormAltroEntiTerzoSettore',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo', 'infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo()
const props = __props
const emits = __emit
let validazione;
const { regimeFiscale } = inject('regimeFiscale')
const validazioneEquoCompenso = ref();
const testoInfoCompilazione = ref([]);
let indexHelperClosing;
let optionsFormaDelTitolo = ref([{name: 'Pubblico', value: 'pubblico'}, {name: 'Privato', value: 'privato'}]);
let optionsFormaDelTitoloEntiDelTerzoSettore = ref([{name: 'Pubblico', value: 'pubblico'}, {name: 'Privato', value: 'privato'}]);
let optionsConferimento = ref([{name: 'Si', value: 'si'}, {name: 'No', value: 'no'}]);
let optionsConferimentoEntiDelTerzoSettore  = ref([{name: 'Si', value: 'si'}, {name: 'No', value: 'no'}]);
switch (props.formName) {
  case 'costituzioneEntiDelPrimoLibroDelCodiceCivile':
    validazione = categorieValidazione.categoriaAltro['sottocategoriaEntiDelterzoSettoreAltriEntiDelLibroPrimoCC']['costituzioneEntiDelPrimoLibroDelCodiceCivile']
    validazioneEquoCompenso.value = categorieValidazione.categoriaAltro['sottocategoriaEntiDelterzoSettoreAltriEntiDelLibroPrimoCC']['costituzioneEntiDelPrimoLibroDelCodiceCivile'];
    testoInfoCompilazione.value =  FormAltroHelper.sottocategoriaEntiDelterzoSettoreAltriEntiDelLibroPrimoCC[props.formName];
    indexHelperClosing = {
      calcolo: FormAltroHelper.sottocategoriaEntiDelterzoSettoreAltriEntiDelLibroPrimoCC[props.formName],
      dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
    }
    if (validazione) {
      validazione.tipo_preventivo.value = 'altro/enti_del_terzo_settore_altri_enti_del_libro_primo_cc/' + props.tipoPreventivo.data.url
    }
    break
  case 'costituzioneEntiDelTerzoSettore':
    validazione = categorieValidazione.categoriaAltro['sottocategoriaEntiDelterzoSettoreAltriEntiDelLibroPrimoCC']['costituzioneEntiDelTerzoSettore']
    validazioneEquoCompenso.value = categorieValidazione.categoriaAltro['sottocategoriaEntiDelterzoSettoreAltriEntiDelLibroPrimoCC']['costituzioneEntiDelTerzoSettore']
    testoInfoCompilazione.value =  FormAltroHelper.sottocategoriaEntiDelterzoSettoreAltriEntiDelLibroPrimoCC[props.formName];
    indexHelperClosing = {
      calcolo: FormAltroHelper.sottocategoriaEntiDelterzoSettoreAltriEntiDelLibroPrimoCC[props.formName],
      dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
    }
    if (validazione) {
      validazione.tipo_preventivo.value = 'altro/enti_del_terzo_settore_altri_enti_del_libro_primo_cc/' + props.tipoPreventivo.data.url
    }
    break
}
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
watch(validazione, (newValue, oldValue) => {
  emits('changeDatiPreventivo')
}, { deep: true })
function changeTipologiaEntiDelPrimoLibro(event){
  if(event.target.value === 'costituzione_comitato_riconosciuto' ||
     event.target.value === 'costituzione_di_associazione_riconosciuta' ||
     event.target.value === 'costituzione_fondazione' ||
     event.target.value === 'costituzione_onlus_riconosciuta' ) {
      optionsFormaDelTitolo.value = [{name: 'Pubblico', value: 'pubblico'}];
    validazione.forma_del_titolo.required = false;
      validazione.numero_marche_da_bollo.value = '1';
      if(event.target.value === 'costituzione_fondazione' ||
         event.target.value === 'costituzione_onlus_riconosciuta') {
        optionsConferimento.value = [{name: 'Si in denaro', value: 'si_in_denaro'},{name: 'Si immobiliare', value: 'si_immobiliare'},{name: 'No', value: 'no'}];
      } else if(event.target.value === 'costituzione_comitato_riconosciuto' ||
        event.target.value ===  'costituzione_di_associazione_riconosciuta'){
        optionsConferimento.value = [{name: 'Si in denaro', value: 'si_in_denaro'},{name: 'No', value: 'no'}];
      } else {
        optionsConferimento.value = [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}];
      }
  } else {
    optionsConferimento.value = [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}];
    if(event.target.value === 'costituzione_societa_di_mutuo_soccorso' ||
       event.target.value === 'costituzione_associazione_non_riconosciuta'||
       event.target.value === 'costituzione_comitato_non_riconosciuto' ||
       event.target.value === 'costituzione_onlus_non_riconosciuta'){
      optionsConferimento.value = [{name: 'Si in denaro', value: 'si_in_denaro'},{name: 'No', value: 'no'}];
    }
    optionsFormaDelTitolo.value = [{name: 'Pubblico', value: 'pubblico'}, {name: 'Privato', value: 'privato'}];
    validazione.forma_del_titolo.required = true;
    validazione.numero_marche_da_bollo.value = '0';
  }
  validazione.conferimento.required = true;
  validazione.conferimento.value = '';
  validazione.valore_conferimento.value = '';
  validazione.numero_conservatorie.value = '1';
  validazione.imposta_ipotecaria_per_ciascuna_conservatoria.value = '';
}
function changeTipologiaEntiTerzoSettore(event){
  if(event.target.value === 'costituzione_associazione_di_promozione_sociale_riconosciuta_ets' ||
     event.target.value === 'costituzione_associazione_riconosciuta_ets' ||
     event.target.value === 'costituzione_cooperativa_sociale_ets' ||
     event.target.value === 'costituzione_impresa_sociale_ets' ||
     event.target.value === 'costituzione_rete_associativa_riconosciuta_ets'){

    validazione.numero_marche_da_bollo.value = '1';
    optionsFormaDelTitoloEntiDelTerzoSettore.value = [{name: 'Pubblico', value: 'pubblico'}];
    optionsConferimentoEntiDelTerzoSettore.value = [{name: 'Si in denaro', value: 'si_in_denaro'}, {name: 'No', value: 'no'}];
  } else {
    validazione.numero_marche_da_bollo.value = '0';
    optionsFormaDelTitoloEntiDelTerzoSettore.value = [{name: 'Pubblico', value: 'pubblico'}, {name: 'Privato', value: 'privato'}];
    if (event.target.value === 'costituzione_associazione_di_promozione_sociale_non_riconosciuta_ets' ||
        event.target.value === 'costituzione_associazione_non_riconosciuta_ets' ||
        event.target.value === 'costituzione_ente_filantropico_sotto_forma_di_associazione_ets' ||
        event.target.value === 'costituzione_ente_filantropico_sotto_forma_di_fondazione_ets' ||
        event.target.value === 'costituzione_organizzazione_di_volontariato_non_riconosciuta_ets' ||
        event.target.value === 'costituzione_organizzazione_di_volontariato_riconosciuta_ets' ||
        event.target.value === 'costituzione_rete_associativa_non_riconosciuta_ets') {
        optionsConferimentoEntiDelTerzoSettore.value = [
          {name: 'Si in denaro', value: 'si_in_denaro'},
          {name: 'No', value: 'no'}
        ];
    } else {
      optionsConferimentoEntiDelTerzoSettore.value = [{name: 'Si', value: 'si'}, {name: 'No', value: 'no'}];
      if (event.target.value === 'costituzione_fondazione_di_partecipazione_ets' || event.target.value === 'costituzione_fondazione_ets') {
        optionsConferimentoEntiDelTerzoSettore.value = [{name: 'Si in denaro', value: 'si_in_denaro'}, {name: 'Si immobiliare', value: 'si_immobiliare'}, {name: 'No', value: 'no'}];
      }
    }
  }
  validazione.conferimento.required = true;
  validazione.conferimento.value = '';
  validazione.valore_conferimento.value = '';
  validazione.numero_conservatorie.value = '1';
  validazione.imposta_ipotecaria_per_ciascuna_conservatoria.value = '';
}

function statoConferimento(event) {
  if (event.target.value === 'si' || event.target.value === 'si_in_denaro' || event.target.value === 'si_immobiliare') {
      validazione.numero_conservatorie.value = '1';
      validazione.valore_conferimento.required = true;
  } else {
    validazione.numero_conservatorie.value = '1';
    validazione.valore_conferimento.required = false;
    validazioneEquoCompenso.value.abilitare_equo_compenso.value = 0;
    validazioneEquoCompenso.value.valore_equo_compenso_calcolato.value = 0;
    validazioneEquoCompenso.value.valore_equo_compenso_calcolato.required = false;
    validazioneEquoCompenso.value.valore_equo_compenso_calcolato_spese_generali.required = false;
    validazioneEquoCompenso.value.tipologia_tabella_calcolo.value = '';
    validazioneEquoCompenso.value.tipologia_tabella_calcolo.required = false;
  }
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'costituzioneEntiDelPrimoLibroDelCodiceCivile')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).tipologia.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipologia.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_select, {
                name: "tipologia",
                options: [
          {name: 'Costituzione associazione non riconosciuta', value: 'costituzione_associazione_non_riconosciuta'},
          {name: 'Costituzione comitato non riconosciuto', value: 'costituzione_comitato_non_riconosciuto'},
          {name: 'Costituzione comitato riconosciuto', value: 'costituzione_comitato_riconosciuto'},
          {name: 'Costituzione di associazione riconosciuta', value: 'costituzione_di_associazione_riconosciuta'},
          {name: 'Costituzione fondazione', value: 'costituzione_fondazione'},
          {name: 'Costituzione onlus non riconosciuta', value: 'costituzione_onlus_non_riconosciuta'},
          {name: 'Costituzione onlus riconosciuta', value: 'costituzione_onlus_riconosciuta'},
          {name: 'Costituzione societa di mutuo soccorso', value: 'costituzione_societa_di_mutuo_soccorso'}
          ],
                isSelected: _unref(validazione).tipologia.value != '',
                state: __props.readonly == true ?'disable':'',
                onChange: _cache[0] || (_cache[0] = $event => (changeTipologiaEntiDelPrimoLibro($event))),
                validateTo: _unref(validazione).tipologia,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).tipologia) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          (
    _unref(validazione).tipologia.value !== 'costituzione_comitato_riconosciuto' &&
    _unref(validazione).tipologia.value !== 'costituzione_di_associazione_riconosciuta' &&
    _unref(validazione).tipologia.value !== 'costituzione_fondazione' &&
    _unref(validazione).tipologia.value !== 'costituzione_onlus_riconosciuta')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_base_select, {
                    name: "forma_del_titolo",
                    options: _unref(optionsFormaDelTitolo),
                    isSelected: _unref(validazione).forma_del_titolo.value != '',
                    state: __props.readonly == true ?'disable':'',
                    validateTo: _unref(validazione).forma_del_titolo,
                    "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                  }, null, 8 /* PROPS */, ["options", "isSelected", "state", "validateTo"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
              _createTextVNode(_toDisplayString(_unref(validazione).conferimento.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.conferimento.ref]
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_base_select, {
                name: "conferimento",
                onChange: _cache[3] || (_cache[3] = $event => (statoConferimento($event))),
                options: _unref(optionsConferimento),
                isSelected: _unref(validazione).conferimento.value != '',
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).conferimento,
                "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).conferimento) = $event))
              }, null, 8 /* PROPS */, ["options", "isSelected", "state", "validateTo"])
            ])
          ]),
          (
    _unref(validazione).conferimento.value === 'si' ||
    _unref(validazione).conferimento.value === 'si_in_denaro' ||
    _unref(validazione).conferimento.value === 'si_immobiliare')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore_conferimento.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_conferimento.ref]
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_base_input_text, {
                    id: "valore_conferimento",
                    name: "valore_conferimento",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore_conferimento,
                    "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).valore_conferimento) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ((_unref(validazione).tipologia.value === 'costituzione_fondazione' || _unref(validazione).tipologia.value === 'costituzione_onlus_riconosciuta') && _unref(validazione).conferimento.value === 'si_immobiliare')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
                  _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_base_input_text, {
                    id: "numero_conservatorie",
                    name: "numero_conservatorie",
                    class: "placeholder-right crm:text-right",
                    placeholder: "Inserire numero conservatorie",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).numero_conservatorie,
                    "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).numero_conservatorie) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).conferimento.value === 'si_immobiliare' && _unref(validazione).numero_conservatorie.value > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.imposta_ipotecaria_per_ciascuna_conservatoria.ref]
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_base_select, {
                    name: "imposta_ipotecaria_per_ciascuna_conservatoria",
                    options: [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}],
                    isSelected: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.value != '',
                    state: __props.readonly == true ?'disable':'',
                    validateTo: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria,
                    "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_21, [
              _createTextVNode(_toDisplayString(_unref(validazione).numero_marche_da_bollo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_marche_da_bollo.ref]
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_base_input_text, {
                id: "numero_marche_da_bollo",
                name: "numero_marche_da_bollo",
                class: "placeholder-right text-end",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).numero_marche_da_bollo,
                "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).numero_marche_da_bollo) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          (
    _unref(validazione).conferimento.value === 'si' ||
    _unref(validazione).conferimento.value === 'si_in_denaro' ||
    _unref(validazione).conferimento.value === 'si_immobiliare')
            ? (_openBlock(), _createBlock(CalcoloEquoCompenso, {
                key: 4,
                "input-riferimento-calcolo": "valore_conferimento",
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]))
            : _createCommentVNode("v-if", true)
        ]))
      : (__props.formName === 'costituzioneEntiDelTerzoSettore')
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_25, [
                _createTextVNode(_toDisplayString(_unref(validazione).tipologia.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipologia.ref]
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_base_select, {
                  name: "tipologia",
                  options: [
          {name: 'Costituzione associazione di promozione sociale non riconosciuta ets', value: 'costituzione_associazione_di_promozione_sociale_non_riconosciuta_ets'},
          {name: 'Costituzione associazione di promozione sociale riconosciuta ets', value: 'costituzione_associazione_di_promozione_sociale_riconosciuta_ets'},
          {name: 'Costituzione associazione non riconosciuta ets', value: 'costituzione_associazione_non_riconosciuta_ets'},
          {name: 'Costituzione associazione riconosciuta ets', value: 'costituzione_associazione_riconosciuta_ets'},
          {name: 'Costituzione cooperativa sociale ets', value: 'costituzione_cooperativa_sociale_ets'},
          {name: 'Costituzione ente filantropico sotto forma di associazione ets', value: 'costituzione_ente_filantropico_sotto_forma_di_associazione_ets'},
          {name: 'Costituzione ente filantropico sotto forma di fondazione ets', value: 'costituzione_ente_filantropico_sotto_forma_di_fondazione_ets'},
          {name: 'Costituzione fondazione di partecipazione ets', value: 'costituzione_fondazione_di_partecipazione_ets'},
          {name: 'Costituzione fondazione ets', value: 'costituzione_fondazione_ets'},
          {name: 'Costituzione impresa sociale ets', value: 'costituzione_impresa_sociale_ets'},
          {name: 'Costituzione organizzazione di volontariato non riconosciuta ets', value: 'costituzione_organizzazione_di_volontariato_non_riconosciuta_ets'},
          {name: 'Costituzione organizzazione di volontariato riconosciuta ets', value: 'costituzione_organizzazione_di_volontariato_riconosciuta_ets'},
          {name: 'Costituzione rete associativa non riconosciuta ets', value: 'costituzione_rete_associativa_non_riconosciuta_ets'},
          {name: 'Costituzione rete associativa riconosciuta ets', value: 'costituzione_rete_associativa_riconosciuta_ets'},
          ],
                  isSelected: _unref(validazione).tipologia.value != '',
                  state: __props.readonly == true ?'disable':'',
                  onChange: _cache[9] || (_cache[9] = $event => (changeTipologiaEntiTerzoSettore($event))),
                  validateTo: _unref(validazione).tipologia,
                  "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).tipologia) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            (
     _unref(validazione).tipologia.value !== 'costituzione_associazione_di_promozione_sociale_riconosciuta_ets' &&
     _unref(validazione).tipologia.value !== 'costituzione_associazione_riconosciuta_ets' &&
     _unref(validazione).tipologia.value !== 'costituzione_cooperativa_sociale_ets' &&
     _unref(validazione).tipologia.value !== 'costituzione_impresa_sociale_ets' &&
     _unref(validazione).tipologia.value !== 'costituzione_rete_associativa_riconosciuta_ets')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_28, [
                    _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_base_select, {
                      name: "forma_del_titolo",
                      options: _unref(optionsFormaDelTitoloEntiDelTerzoSettore),
                      isSelected: _unref(validazione).forma_del_titolo.value != '',
                      state: __props.readonly == true ?'disable':'',
                      validateTo: _unref(validazione).forma_del_titolo,
                      "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                    }, null, 8 /* PROPS */, ["options", "isSelected", "state", "validateTo"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_30, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_31, [
                _createTextVNode(_toDisplayString(_unref(validazione).conferimento.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.conferimento.ref]
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_base_select, {
                  name: "conferimento",
                  onChange: _cache[12] || (_cache[12] = $event => (statoConferimento($event))),
                  options: _unref(optionsConferimentoEntiDelTerzoSettore),
                  isSelected: _unref(validazione).conferimento.value != '',
                  state: __props.readonly == true ?'disable':'',
                  validateTo: _unref(validazione).conferimento,
                  "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).conferimento) = $event))
                }, null, 8 /* PROPS */, ["options", "isSelected", "state", "validateTo"])
              ])
            ]),
            (
    _unref(validazione).conferimento.value === 'si' ||
    _unref(validazione).conferimento.value === 'si_in_denaro' ||
    _unref(validazione).conferimento.value === 'si_immobiliare')
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_34, [
                    _createTextVNode(_toDisplayString(_unref(validazione).valore_conferimento.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_conferimento.ref]
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_base_input_text, {
                      id: "valore_conferimento",
                      name: "valore_conferimento",
                      class: "placeholder-right",
                      placeholder: "0,00",
                      disabled: __props.readonly,
                      "validate-to": _unref(validazione).valore_conferimento,
                      "onUpdate:validateTo": _cache[14] || (_cache[14] = $event => ((_unref(validazione).valore_conferimento) = $event))
                    }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ((_unref(validazione).tipologia.value == 'costituzione_fondazione_ets' || _unref(validazione).tipologia.value == 'costituzione_fondazione_di_partecipazione_ets') &&  _unref(validazione).conferimento.value === 'si_immobiliare')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_37, [
                    _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_base_input_text, {
                      id: "numero_conservatorie",
                      name: "numero_conservatorie",
                      class: "placeholder-right",
                      placeholder: "0,00",
                      disabled: __props.readonly,
                      "validate-to": _unref(validazione).numero_conservatorie,
                      "onUpdate:validateTo": _cache[15] || (_cache[15] = $event => ((_unref(validazione).numero_conservatorie) = $event))
                    }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ((_unref(validazione).tipologia.value == 'costituzione_fondazione_ets' || _unref(validazione).tipologia.value == 'costituzione_fondazione_di_partecipazione_ets') && _unref(validazione).numero_conservatorie.value > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_40, [
                    _createTextVNode(_toDisplayString(_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.imposta_ipotecaria_per_ciascuna_conservatoria.ref]
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_base_select, {
                      name: "imposta_ipotecaria_per_ciascuna_conservatoria",
                      options: [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}],
                      isSelected: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.value != '',
                      state: __props.readonly == true ?'disable':'',
                      validateTo: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria,
                      "onUpdate:validateTo": _cache[16] || (_cache[16] = $event => ((_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria) = $event))
                    }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_42, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_43, [
                _createTextVNode(_toDisplayString(_unref(validazione).numero_marche_da_bollo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_marche_da_bollo.ref]
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_base_input_text, {
                  id: "numero_marche_da_bollo",
                  name: "numero_marche_da_bollo",
                  class: "placeholder-right text-end",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).numero_marche_da_bollo,
                  "onUpdate:validateTo": _cache[17] || (_cache[17] = $event => ((_unref(validazione).numero_marche_da_bollo) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            (
    _unref(validazione).conferimento.value === 'si' ||
    _unref(validazione).conferimento.value === 'si_in_denaro' ||
    _unref(validazione).conferimento.value === 'si_immobiliare')
              ? (_openBlock(), _createBlock(CalcoloEquoCompenso, {
                  key: 4,
                  "input-riferimento-calcolo": "valore_conferimento",
                  validazione: validazioneEquoCompenso.value,
                  helper: _unref(indexHelperClosing),
                  readonly: __props.readonly
                }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}